export default "__VITE_ASSET__DOSjpo1F__"